<template>
  <div>
    <WsMain v-if="isLoading.breadCrumbsItems">
      <v-skeleton-loader
        type="list-item-three-line"
      ></v-skeleton-loader>
    </WsMain>
    <WsRead
      v-else
      ref="WsRead"
      localeMode
      :label="label"
      :id="_syncApiId"
      :fields="fields"
      :editable="false"
      :deletable="false"
      :fetchUrl="_fetchUrl"
      :modelName="modelName"
      :customBtns="customBtns"
      :primary="pageSetting.primary"
      :customBreadcrumbsItems="_customBreadcrumbsItems"
      @input="$_getModelData"
      @clickOpenReSync="$_onClickOpenReSync"
    />
    <WsAlertDialog
      ref="WsAlertDialog"
      title="確定要再次開放同步嗎？"
      :description="alertPopup.description"
      btnText="確認"
      color="primary"
      @submit="$_onOpenReSync($event)"
    />
  </div>
</template>

<script>
import model from "@/models/syncApi";
import S_factory from "@/services/api/v1/factory";
import S_syncApi from "@/services/api/v1/syncApi";

export default {
  data() {
    return {
      isLoading: {
        breadCrumbsItems: true,
      },
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      pageSetting: {
        primary: [
          {
            type: "infoCard",
            floors: [
              {
                title: "資訊",
                fields: [
                  "module",
                  "module_id",
                  "module_uuid",
                  "status",
                  "message",
                  "date",
                ],
              },
            ],
          },
        ],
      },
      parentData: {},
      modelData: {},
      alertPopup: {
        description: '',
      },
      customBtns: [{
        title: `再次開放同步`,
        color: "textSecondary",
        outlined: true,
        icon: "mdi-update",
        emit: "clickOpenReSync",
      }],
    };
  },
  computed: {
    _syncApiId() {
      return this.$route.params.syncApiId;
    },
    _fetchUrl() {
      return `/factory_api_sync_module/${this._syncApiId}`;
    },
    _currentFactoryId() {
      return this.$route.params.id;
    },
    _customBreadcrumbsItems() {
      return [
        {
          text: '工廠管理',
          to: '/factory',
          disabled: false,
        },
        {
          text: this.parentData.name,
          to: `/factory/${this._currentFactoryId}`,
          disabled: false,
        },
        {
          text: model.label,
          to: `/factory/${this._currentFactoryId}/sync_api`,
          disabled: false,
        },
        {
          text: this.modelData.module_id,
          disabled: true,
        }
      ];
    },
  },
  async mounted() {
    this.isLoading.breadCrumbsItems = true;
    this.parentData = await this.$_getParentData(this._currentFactoryId);
    this.isLoading.breadCrumbsItems = false;
  },
  methods: {
    async $_getParentData(factoryId) {
      return await S_factory.show(factoryId);
    },
    $_getModelData($event) {
      this.modelData = $event;
    },
    $_onClickOpenReSync() {
      const {module, module_id} = this.modelData;
      this.alertPopup.description = `模組：${module}, 模組ID：${module_id}`;
      this.$refs.WsAlertDialog.open(this.modelData);
    },
    async $_onOpenReSync($event) {
      if (!this.$refs.WsAlertDialog) return;
      this.$refs.WsAlertDialog.startLoading();
      await S_syncApi.openSync($event.id);
      await this.$refs.WsRead.$_fetchData();
      this.$refs.WsAlertDialog.close();
      this.$refs.WsAlertDialog.stopLoading();
    }
  }
};
</script>